import React from 'react';
import GumballIcon, { resolveIconName } from './GumballIcon';

/** Renders h3 with icon — supports icon field or legacy emoji-prefixed titles */
export default function StoryHeading({ title, icon, className = '' }) {
  const emojiMatch = title?.match(/^(\p{Extended_Pictographic})\s*/u);
  const emoji = emojiMatch?.[1];
  const text = emoji ? title.slice(emoji.length).trim() : title;
  const iconName = resolveIconName(icon, emoji);

  return (
    <h3 className={`story-heading ${className}`.trim()}>
      <GumballIcon name={iconName} className="story-heading-icon" size={22} />
      <span>{text}</span>
    </h3>
  );
}
